import { cssInterop } from 'nativewind'
import * as React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Svg } from 'react-native-svg'

cssInterop(Svg, {
  className: {
    target: 'style',
  },
})

export const SomethingWentWrongIllustration = (
  props: SvgProps & {
    className?: string
  }
) => (
  <Svg viewBox="0 0 295 149" fill="none" {...props}>
    <Path
      fill="#003D2B"
      fillOpacity={0.05}
      d="M223.83 148.483H71.17C32.16 148.483.5 119.035.5 82.63c0-36.351 31.66-65.799 70.67-65.799h152.66c39.01 0 70.67 29.502 70.67 65.853s-31.66 65.799-70.67 65.799Z"
    />
    <G clipPath="url(#a)">
      <Path fill="#fff" d="M211.096 2.304 140.181 112.75 69.265 2.304h141.831Z" />
      <Path fill="#ADE6B9" d="M225.06 2.304 154.144 112.75 83.229 2.304H225.06Z" />
      <Path
        stroke="#003D2B"
        strokeWidth={1.5}
        d="M212.365 2.304 141.449 112.75 70.534 2.304h141.831Z"
      />
      <Path
        stroke="#003D2B"
        strokeWidth={1.5}
        d="M141.468 16.1731L141.329 65.6011M141.329 81.1041L141.298 76.8214"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M49.5.701h195v114.597h-195z" />
      </ClipPath>
    </Defs>
  </Svg>
)
